export default "__VITE_ASSET__DHmQC2Pr__"